var Linkr = require('./Linkr.js');
var config = __RLZ_CONFIG__;
config.WDPLinkr = new Linkr(config);
config.build = {
    git: { hash: __COMMIT_HASH__ },
    env: __PROCESS_ENV__
};

export default config;



/** WEBPACK FOOTER **
 ** ../src/config/index.js
 **/